// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3ahYv","row":"ProcedureTreatmentSummary_row__3kOfn"};